//cyq
import * as React from 'react'
import './index.less'
import {axios_} from '../../../tools/axios_'
import Cards from './cards'
import {connect} from 'react-redux'
import ReactEcharts from 'echarts-for-react';
import {Utils} from "../../../tools/utils"
class ClientAnalyze extends React.Component{
  constructor (props){
    super(props)
    this.state={
      yesterdayCusotmer:0,//昨日新客户
      customerTotal:0,//客户总量
      amount:0,//保障额度
      manNo:0,
      womanNo:0,
      ageMap:[],//年龄分布
    }
  }
  componentDidMount(){
    Utils.insertChama();//引入插码文件
    this.getData();
  }

  getData(){
    axios_({
      url:'customerAnalyzeAll',
      method:'get',
      headers: {'access-token': this.props.token}
    }).then(res=>{
      // if(res.data.rel){ //后台该改口不告诉前端啊）
      if(res.data.status===200){
        this.setState({
          yesterdayCusotmer:res.data.data.yestDCustomer[0].yesterdayCusotmer,
          customerTotal:res.data.data.customerTotal[0].customerTotal,
          amount:(res.data.data.customerTotal[0].amount)/10000,
          manNo:res.data.data.malePercentage,
          womanNo:res.data.data.femalePercentage,
          ageMap:res.data.data.age
        })
      }
    })
  }

  getPieOption=(data)=>{

    const PieData=[
      {value:this.state.manNo||0, name:'男'},   //c,b
      {value:this.state.womanNo||0, name:'女'},
    ]

    return {
      color: [
        "#5B9BD5",
        "#ED7D31",
      ],
      title: {
        text: '客户性别分布情况',
        left: 'center',
        top: 20,
        textStyle: {
          fontSize: 18,
          color:'#000'
        },
      },
      tooltip : {
        trigger: 'item',
        formatter: "{b}：{c}%",
      },
      calculable: true,
      series : [
        {
          name: '访问来源',   //a
          type: 'pie',
          radius: ['35%','60%'],
          center: ['50%', '65%'],
          data:PieData,
          itemStyle : {
            normal : {
              label : {
                formatter:"{b} : {c}%"
              },
            }
          },
        }
      ]
    }
  }

  getBarOption=(data)=>{
    const ageData = this.state.ageMap;
    const ageDataX = ageData.map((v,i)=>{
      return v.age
    });
    const ageDataY = ageData.map((v,i)=>{
      return v.ageTotal
    });
    return{
      title: {
        text: '客户年龄段分布情况',
        left: 'center',
        top:'6%'
      },
      // grid:{
      //   top:'21%',
      //   // bottom:'12%',
      // },
      color:[ "#5B9BD5"],
      tooltip: {},
      legend: {
        data:['年龄'],
        left: 'right'
      },
      xAxis: {
        name:'年龄段（岁）',
        nameLocation:'center',
        nameGap:'30', //name 与轴距离
        data: ageDataX,//["衬衫","羊毛衫","雪纺衫","裤子","高跟鞋","袜子"]
      },
      yAxis: {
        name:'人数（人）',
        nameLocation:'center',
        splitLine:{  //网格线
          show:false,
        },
        axisLine:{   //y轴轴线
          show:false,
        },
        axisLabel:{
          show:false,//轴刻度标签
        },
        axisTick:{
          show:false, //轴刻度
        }
      },
      series: [{
        name: '年龄',
        type: 'bar',
        data:ageDataY,// [5, 20, 36, 10, 10, 20],
        label : {
          show: true, position: 'top',
          color:'#000'
        },
        itemStyle : {

        },
        splitLine:{
          show:false,
        }
      }]
    }
  }

  render(){
    return(
      <div className="client_analyze">
        <header>
          <Cards
            count={this.state.yesterdayCusotmer||0}
            describe='统计昨日0点至24点的数据量'
            title='昨日新客户（人）'/>
          <Cards
            count={this.state.customerTotal||0}
            describe="统计截至昨日24点数据"
            title='客户总量（人）'/>
          <Cards
            count={formatNumber((  this.state.amount||0.00).toFixed(2))}
            describe="统计截至昨日24点数据"
            title='保障额度（万元）'/>
        </header>
        <div className="client_charts">
          <ReactEcharts
            className="item"
            option={this.getPieOption()}
            notMerge={true}
            lazyUpdate={true}
            // style={{height: '350px', width: '100%'}}
          />
          <ReactEcharts
            className="item"
            option={this.getBarOption()}
            notMerge={true}
            lazyUpdate={true}
            // style={{height: '350px', width: '100%'}}
          />
        </div>
      </div>
    )
  }
}
function formatNumber(strNum){
  if (strNum.length <= 3) {
    return strNum;
  }
  // eslint-disable-next-line
  if (!/^(\+|-)?(\d+)(\.\d+)?$/.test(strNum)) {
    return strNum;
  }
  let a = RegExp.$1, b = RegExp.$2, c = RegExp.$3;
  let re = new RegExp();
  re.compile("(\\d)(\\d{3})(,|$)");
  while (re.test(b)) {
    b = b.replace(re, "$1,$2$3");
  }
  return a + "" + b + "" + c;
}

function mapState (state) {
  return {
    token: state.token
  }
}
export default connect(mapState)(ClientAnalyze)
